import { render, staticRenderFns } from "./StirpesYN.vue?vue&type=template&id=0f23fe5b"
import script from "./StirpesYN.vue?vue&type=script&lang=js"
export * from "./StirpesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports